export default "__VITE_ASSET__DEEjHJIm__"